import InlineSvg from "vue-inline-svg";
import { Component, Prop, Vue, toNative } from "vue-facing-decorator";
import { h } from "vue";
import { MiaPlaza } from "../../Reinforced.Typings";

export type IFileImage = string;
export type ILazySizes = MiaPlaza.Navigation.JSON.Converters.ILazySizes;
export type Image = IFileImage | ILazySizes;

export function isLazySizes(from: Image): from is MiaPlaza.Navigation.JSON.Converters.ILazySizes {
	return (from as MiaPlaza.Navigation.JSON.Converters.ILazySizes).OriginalUrl !== undefined;
}

@Component
export class ResponsiveImage extends Vue {
	@Prop({ required: true }) protected from!: Image;
	@Prop({ required: false, default: true }) protected inlineSvg!: boolean;

	private isLazy = false;

	get OriginalUrl(): string {
		if (isLazySizes(this.from)) {
			return this.from.OriginalUrl;
		}
		else {
			return this.from;
		}
	}

	get Sizes(): MiaPlaza.Navigation.JSON.Converters.IPictureAtSize[] | null {
		if (isLazySizes(this.from)) {
			return this.from.Sizes || null;
		}
		else {
			return null;
		}
	}

	get AspectRatio(): string | null {
		if (isLazySizes(this.from)) {
			return this.from.AspectRatio;
		}
		else {
			return null;
		}
	}

	protected render() {
		const classes: string[] = ["mia-img"];
		if (this.OriginalUrl.split("?")[0].endsWith(".svg") && this.inlineSvg) {
			// If the image is svg, we want to make it inline.
			// So we can apply CSS to it and make animations work in Safari, see #12244.
			return h("div", {
				class: classes,
			},
			[h(InlineSvg, {
				src: this.OriginalUrl,
			}),
			]);
		}

		const attrs: any = {};
		if (this.Sizes && this.Sizes.length > 0) {
			attrs.src = this.Sizes[0].Url;
			attrs["data-sizes"] = "auto";
			attrs["data-aspectratio"] = this.AspectRatio;
			attrs["data-srcset"] = this.Sizes.map(
				(pic: MiaPlaza.Navigation.JSON.Converters.IPictureAtSize) => `${pic.Url} ${pic.Width}w`)
				.join(", ");
			classes.push("lazyload");
			classes.push("mia-blur-up");
			this.isLazy = true;
		}
		else {
			attrs.src = this.OriginalUrl;
		}

		return h("img", {
			...attrs,
			class: classes,
		});
	}

	protected updated(): void {
		// This is probably not necessary if all for loops set keys correctly:
		// https://github.com/aFarkas/lazysizes/issues/367#issuecomment-289264840
		if (this.isLazy) {
			this.$el.classList.add("lazyload");
		}
	}
}

export default toNative(ResponsiveImage);
